export default "__VITE_ASSET__BpU4oD$7__"